<template>
    <div class="login">
        <div class="brand">
            <svg class="brand-logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.1" width="35.999977111816406" height="23.58822250366211"
                viewBox="0 0 35.999977111816406 23.58822250366211" data-v-9746107e="">
                <g style="mix-blend-mode:passthrough;">
                    <g>
                        <g style="mix-blend-mode:passthrough;">
                            <path
                                d="M0.27554,20.0484C0.27554,20.0484,9.90134,1.31344,9.90134,1.31344C10.785,-0.406398,13.2217,-0.445562,14.1597,1.24499C14.1597,1.24499,24.5153,19.9073,24.5153,19.9073C25.5632,21.7957,23.8108,24.012,21.7399,23.4175C21.7399,23.4175,13.2101,20.9691,13.2101,20.9691C12.776,20.8445,12.3159,20.8444,11.8819,20.9689C11.8819,20.9689,3.08678,23.4904,3.08678,23.4904C1.05174,24.0738,-0.6943,21.936,0.27554,20.0484C0.27554,20.0484,0.27554,20.0484,0.27554,20.0484Z"
                                fill="#3970E3" fill-opacity="1"></path>
                        </g>
                        <g style="mix-blend-mode:passthrough;">
                            <path
                                d="M28.93594544921875,22.2763C28.93594544921875,22.2763,32.91183544921875,23.4175,32.91183544921875,23.4175C34.98273544921875,24.012,36.73503544921875,21.7957,35.68723544921875,19.9073C35.68723544921875,19.9073,25.33164544921875,1.24499,25.33164544921875,1.24499C24.393565449218748,-0.445562,21.95685544921875,-0.406398,21.07322544921875,1.31344C21.07322544921875,1.31344,19.36883544921875,4.63074,19.36883544921875,4.63074C19.36883544921875,4.63074,28.93594544921875,22.2763,28.93594544921875,22.2763C28.93594544921875,22.2763,28.93594544921875,22.2763,28.93594544921875,22.2763Z"
                                fill="#3970E3" fill-opacity="0.5"></path>
                        </g>
                    </g>
                </g>
            </svg>
            <span class="brand-text">MasterGo</span>
        </div>
        <div class="login-card">
            <a class="a-back" @click="back">
                <a-button type="link">
                    <img class="icon"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAB30lEQVRoge2ZPW8UMRCGn0F0XNrU663zr5CIyHFQEsKHkpDkUgJhvU3yq+hz/bVeWoZiiZAuLnJrjzeR9m1Hsp7X44/xGCZNmjRpa6mKa8KV82GeOpTk4NlKquLa7gqYAwosVgc7zdDhnmUDe4hUxfnuBz089BOYlInnWcAeoruZFzZhRWBv6LBlMtDDf4d78ADXt+vZ4AzYG+iXzTdgEYler9azfY7lz9DhzQ3U7e8lwttIKBkejE+h2neXir6PhLLAg2EGqqZbWsOD0SlU+e5C0MNIKCs8GCyhf/AfIqHs8JDZgPPhHDiKhEzgIeMecG04ozA8ZMqAa8MZysdIyBQeMhhwPnwFPkVC5vCQuIRcE04ZER4SMuCacIrwORIqBg8DM1D7cPIY4GGAgboJxwpfIqHi8JC1lJDyrzsG7oHah5N4FuRmtX7xqmQWDDZxWRNJaX8MJgwvsjImjEsJexPZTo6xTBQqp+1MFHzQ2JgwuXxKmjC7PaumW4rE3sV5TYzUVslnwrx+sTZhX4DdtRaj3bl0E2UqyP/N3Uh/NM1Eme60iK5ez94BkY8MfVnvdk/gg6M3sUD5uRFRlF+Dh03E2l4bX0yivLmd7/jiHElSlcoHX7Vhf2yUSZMmjay/AkobJMlU9UcAAAAASUVORK5CYII=" />返回
                </a-button>
            </a>
            <div class="content">
                <div class="title">登录以继续使用

                    <a-button type="link" class="forget">
                        忘记密码
                    </a-button>
                </div>
                <a-input class="input" v-model:value="phone" placeholder="输入手机号或邮箱" size="large" />

                <a-input-password class="input" v-model:value="value" placeholder="输入密码" size="large" />

                <a-checkbox class="check" v-model:checked="checked">同意 <a class="a-link">《服务条款》</a> 与 <a
                        class="a-link">《隐私条款》</a></a-checkbox>
                <a-button type="primary btn-send" size="large" block>
                    立即登录
                </a-button>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            checked: false,
            phone: "",
        }
    },
    methods: {
        back() {
            this.$router.go(-1)
        }
    }
}
</script>

<style scoped>
.login {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 600px;
    background-image: url('@/assets/image/login-bg.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}

.brand {
    width: 100%;
    position: relative;
    top: 12%;
}

.brand .brand-text {
    margin-left: 1rem;
    font-size: 22px;
    font-weight: bold;
    position: relative;
    top: -2px;
}

.login-card {
    background: #fff;
    width: 100%;
    max-width: 400px;
    margin: auto;
    position: relative;
    background: #fff;
    -webkit-box-shadow: 0 4px 6px rgb(0 0 0 / 10%), 0 12px 20px rgb(38 38 38 / 12%);
    box-shadow: 0 4px 6px rgb(0 0 0 / 10%), 0 12px 20px rgb(38 38 38 / 12%);
    border-radius: 12px;
    padding: 35px 36px 50px;
    text-align: left;
}

.login-card .title {
    font-size: 1.4rem;
    text-align: left;
    margin-bottom: 45px;
}

.a-back {
    color: var(--primaryColor);
    display: inline-block;
    margin-bottom: 15px;
    font-size: 1rem;
    position: relative;
    left: -12px;
}

.a-back .icon {
    height: 18px;
    position: relative;
    top: -2px;
}

.forget {
    font-size: 14px;
    float: right;
    line-height: 34px;
    padding: 0;
}

.btn-send {
    border-radius: 8px;
}

.input {
    margin: 0.4rem 0;
}

.check {
    margin: 2rem 0 1rem;
    text-align: left;
}

.a-link {
    color: #1890ff;
}

.a-link:hover {
    color: #40a9ff;
}

@media (max-width: 765px) {
    .login-card {
        background: transparent;
        box-shadow: none;
    }
}
</style>